import { LogGroup } from "../.././MyHelpers";
export class Decceleration
{
	public startingSpeed: number = 0;
	public overshootDistance: number = 0;
	public distance: number = 0;
	public targetDistance: number = 0;
	public duration: number = 0;
	public decceleration: number = 0;

	protected logGroup: LogGroup;

	public constructor(logGroup: LogGroup)
	{
		this.logGroup = logGroup.Add("Acceleration");
	}

	public CalculateDistance(time: number): number {
		return (this.startingSpeed * time) - (-1 * this.decceleration * time * time / 2);
	}
}